import React, { createContext, createRef, useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { node } from 'prop-types';

import { genericStorage } from '@ajaibid/utils';
import { GENERIC_STORAGE_KEY } from '@config/constanta';
import { layoutReducer } from './reducer';
import { LayoutActionType, defaultLayoutState, defaultRefs } from './constant';

export const LayoutContext = createContext({
  isReady: false,
  layout: defaultLayoutState,
  dispatch: () => {},
  refs: { current: defaultRefs },
});

function LayoutProvider({ children }) {
  const [layout, dispatch] = useReducer(layoutReducer, defaultLayoutState);
  const [isReady, setIsReady] = useState(false);
  const refs = useRef(defaultRefs);

  // Load from genericStorage
  useEffect(() => {
    const load = () => {
      const textData = genericStorage.get(GENERIC_STORAGE_KEY.layout);

      try {
        const data = textData ? JSON.parse(textData) : defaultLayoutState;
        dispatch({ type: LayoutActionType.LOAD, data });
      } catch (err) {
        console.error('Fail load layout data from localStorage');
      }
      setIsReady(true);
    };

    if (isReady) {
      return;
    }

    load();
  }, [isReady]);

  // Save data to genericStorage
  useEffect(() => {
    if (!isReady) {
      return;
    }

    const textData = JSON.stringify(layout);
    genericStorage.set(GENERIC_STORAGE_KEY.layout, textData);
  }, [layout, isReady]);

  const state = useMemo(
    () => ({
      isReady,
      layout,
      dispatch,
      refs,
    }),
    [isReady, layout, dispatch]
  );

  return <LayoutContext.Provider value={state}>{children}</LayoutContext.Provider>;
}

LayoutProvider.defaultProps = {
  children: null,
};
LayoutProvider.propTypes = {
  children: node,
};

export default LayoutProvider;
